export default function BotonDiv2({ tituloBoton, onClick }) {
  return (
    <div onClick={onClick} className="botonCard2">
      {tituloBoton}
    </div>
  );
}
